import './video-archive-grid.scss';

let activeLoadMoreController = null;

function getAjaxConfig() {
	if ( typeof window.VideoArchive !== 'object' || window.VideoArchive === null ) {
		return null;
	}

	if ( ! window.VideoArchive.ajaxUrl || ! window.VideoArchive.nonce ) {
		return null;
	}

	return window.VideoArchive;
}

function getFilterForm() {
	return document.querySelector( '[data-component="video-filter"]' );
}

function buildFilterParams( form ) {
	const formData = new FormData( form );
	const params = new URLSearchParams();

	formData.forEach( ( value, key ) => {
		if ( typeof value !== 'string' || value.trim() === '' ) {
			return;
		}

		params.append( key, value );
	} );

	return params;
}

function updateArchiveUrl( form, loadedPages ) {
	if ( ! form ) {
		return;
	}

	const params = buildFilterParams( form );

	if ( loadedPages > 1 ) {
		params.set( 'video_pagina', String( loadedPages ) );
	}

	const query = params.toString();
	const url = query ? form.action + '?' + query : form.action;

	window.history.pushState( {}, '', url );
}

function setLoadMoreLoadingState( button, loading ) {
	if ( ! button ) {
		return;
	}

	button.classList.toggle( '-loading', loading );
	button.setAttribute( 'aria-busy', loading ? 'true' : 'false' );

	if ( loading ) {
		button.setAttribute( 'aria-disabled', 'true' );
	} else {
		button.removeAttribute( 'aria-disabled' );
	}
}

function updateLoadMoreButton( button, payload ) {
	if ( ! button || ! payload ) {
		return;
	}

	const loadedPages = parseInt( payload.loadedPages, 10 ) || 1;
	const hasMore = Boolean( payload.hasMore );

	button.dataset.currentPage = String( loadedPages );

	if ( payload.nextUrl ) {
		button.href = payload.nextUrl;
	}

	if ( hasMore ) {
		button.removeAttribute( 'hidden' );
	} else {
		button.setAttribute( 'hidden', '' );
	}
}

function submitLoadMore( button ) {
	const ajaxConfig = getAjaxConfig();
	const form = getFilterForm();
	const results = document.querySelector( '[data-video-archive-results]' );
	const grid = results ? results.querySelector( '[data-video-archive-grid]' ) : null;

	if ( ! ajaxConfig || ! form || ! results || ! grid || typeof window.fetch !== 'function' ) {
		return false;
	}

	const currentPage = parseInt( button.dataset.currentPage, 10 ) || 1;
	const body = buildFilterParams( form );

	body.append( 'action', ajaxConfig.loadMoreAction || 'load_more_video_archive' );
	body.append( 'nonce', ajaxConfig.nonce );
	body.append( 'video_pagina', String( currentPage ) );

	if ( activeLoadMoreController ) {
		activeLoadMoreController.abort();
	}

	const requestController = new AbortController();
	activeLoadMoreController = requestController;

	setLoadMoreLoadingState( button, true );
	results.setAttribute( 'aria-busy', 'true' );

	window.fetch(
		ajaxConfig.ajaxUrl,
		{
			method: 'POST',
			credentials: 'same-origin',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
			},
			signal: requestController.signal,
			body: body.toString(),
		}
	)
		.then( ( response ) => {
			if ( ! response.ok ) {
				throw new Error( 'Video archive load more request failed.' );
			}

			return response.json();
		} )
		.then( ( payload ) => {
			if ( ! payload || ! payload.success || ! payload.data || typeof payload.data.itemsHtml !== 'string' ) {
				throw new Error( 'Video archive load more response was invalid.' );
			}

			if ( payload.data.itemsHtml ) {
				grid.insertAdjacentHTML( 'beforeend', payload.data.itemsHtml );
			}

			updateLoadMoreButton( button, payload.data );
			updateArchiveUrl( form, parseInt( payload.data.loadedPages, 10 ) || 1 );
		} )
		.catch( ( error ) => {
			if ( error.name === 'AbortError' ) {
				return;
			}

			window.location.href = button.href;
		} )
		.finally( () => {
			if ( activeLoadMoreController !== requestController ) {
				return;
			}

			activeLoadMoreController = null;
			setLoadMoreLoadingState( button, false );
			results.setAttribute( 'aria-busy', 'false' );
		} );

	return true;
}

function initVideoArchiveGrid() {
	const results = document.querySelector( '[data-video-archive-results]' );

	if ( ! results || results.dataset.videoArchiveGridInitialized === 'true' ) {
		return;
	}

	results.dataset.videoArchiveGridInitialized = 'true';

	results.addEventListener( 'click', ( event ) => {
		const button = event.target.closest( '[data-video-load-more]' );

		if ( ! button || ! results.contains( button ) ) {
			return;
		}

		if ( ! submitLoadMore( button ) ) {
			return;
		}

		event.preventDefault();
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', initVideoArchiveGrid );
} else {
	initVideoArchiveGrid();
}
